// extracted by mini-css-extract-plugin
export default {"container":"container-k1ki8goz","star":"star-WzHZsMm8","active":"active-NcqDxJQ1"};